"use client"

import { Button } from "@/components/ui/button";
import { LoaderCircle } from "lucide-react";

interface ILoaderButtonProps {
  isPending: boolean;
  text: string;
  pendingText: string;
  children?: React.ReactNode;
  className?: string;
  variant?: "default" | "outline" | "secondary" | "ghost" | "destructive" | "link";
  onClick?: (() => void) | undefined;
}

export const LoaderButton = ({isPending,variant, text, pendingText, onClick, ...props}:ILoaderButtonProps) => {
  return (
    <Button variant={variant || 'default'} onClick={onClick} className={`w-full mt-4 ${props.className}`} type="submit" disabled={isPending}> 
    { isPending && <LoaderCircle className="h-4 w-4 animate-spin mr-2" />}
      {props.children}
      {isPending ? pendingText : text}
    </Button>
)
};